import React, { HTMLAttributes } from 'react'
import { TextThemeType } from '../../_config/types'
import { getThemedText } from '../../_common/functions'

interface ButtonProps extends HTMLAttributes<HTMLHeadingElement> {
    theme?: TextThemeType
    className?: string
}

const H2: React.FC<ButtonProps> = ({ children, theme = '', className = '', ...args }) => {
    return (
        <h2 className={`${getThemedText(theme)} text-[2.667rem] font-bold leading-[4rem] ${className}`} {...args}>
            {children}
        </h2>
    )
}

export default H2
